import { Component } from '@angular/core'
import { IConversationVM, openConversationFilter } from '@engineering11/messaging-web'
import { ConversationTypes, IEmployerConversationVM } from 'shared-lib'

@Component({
  selector: 'nav-item-job-application-messages',
  templateUrl: './job-application-messages-nav.component.html',
  styleUrls: ['./job-application-messages-nav.component.scss'],
})
export class JobApplicationMessagesNavComponent {
  ConversationTypes = ConversationTypes
  groupFn: (obj: IConversationVM) => string = (obj: IEmployerConversationVM) =>
    obj.clientMetadata?.jobPostId ?? obj.clientMetadata?.jobPostName ?? obj.shortName // TODO: Address missing value
  groupNameFn: (obj: IConversationVM) => string = (obj: IEmployerConversationVM) => obj.clientMetadata?.jobPostName ?? obj.shortName // TODO: Address missing value
  groupSubtitleFn: (obj: IConversationVM) => string = (obj: IEmployerConversationVM) => obj.clientMetadata?.location?.name ?? ''
  openConversationFilter = openConversationFilter
}
